module.exports = __webpack_public_path__ + "fonts/BridgestoneType-Medium.1da65fd2.ttf";